import React from 'react';
import { Stack, Box, Typography } from '@mui/material';
import { ageOptions, languageOptions } from 'shared/targetingConfigOptions';
import { useTargetingConfigContext } from './TargetingConfigContext';
import { AutocompleteMultiple } from 'components/AutocompleteMultiple';
import { ButtonGroupRadioSwitch } from 'components/ButtonGroupRadioSwitch';

export const SociodemographicConfig = () => {
  const { gender, setGender, age, setAge, languages, setLanguages } = useTargetingConfigContext();

  // in context stored as string[], in autocomplete needed as {label, value}[]
  const languageAutocompleteValue = languages
    .map((lang) => languageOptions.find((langOpt) => langOpt.value === lang))
    .filter(Boolean);

  return (
    <Stack gap={5} alignItems="flex-start">
      <Box>
        <Typography fontWeight={700} mb={4}>
          Geschlecht
        </Typography>
        <ButtonGroupRadioSwitch
          clapToVertical={false}
          multiple={true}
          value={gender}
          onChange={setGender}
          options={[
            { value: 'female', label: 'Weiblich' },
            { value: 'male', label: 'Männlich' },
          ]}
          includeAllOption={true}
        />
      </Box>
      <Box>
        <Typography fontWeight={700} mb={4}>
          Altersgruppe
        </Typography>
        <ButtonGroupRadioSwitch
          multiple={true}
          value={age}
          onChange={setAge}
          options={[...ageOptions.map((o) => ({ value: o.value, label: o.label }))]}
          includeAllOption={true}
        />
      </Box>
      <Box width={{ xs: '100%', sm: '55%' }}>
        <Typography fontWeight={700} mb={4}>
          Welche Sprachen spricht deine Zielgruppe?
        </Typography>
        <AutocompleteMultiple
          options={languageOptions}
          getOptionLabel={(option) => option.label}
          value={languageAutocompleteValue}
          onChange={(_, val) => setLanguages(val.map((v) => v.value))}
          label="Sprache"
          placeholder="Sprache wählen"
        />
      </Box>
    </Stack>
  );
};
